
import React, {  useEffect } from 'react'; 
import ElementContent from "../components/element-content";
import {
    useSearchParams,
} from "react-router-dom"; 
import Container from '@mui/material/Container';






export default function Element() {

    let [searchParams, setSearchParams] = useSearchParams();
    const [expContentData, setExpContentData] = React.useState<any>(null);


    useEffect(() => {
        //console.log("sssssss:",searchParams.get("vistaId"),searchParams.get("alleleId"));  
        let _vistaId = searchParams.get("vistaId");
        let _alleleId:any = searchParams.get("alleleId");
        let _stage:any = searchParams.get("stage");
        let _backbone:any = searchParams.get("backbone");

        if(_vistaId)
        {
            if(!_alleleId)
                _alleleId = 0; 

            setExpContentData({"rowData":{"vistaId":_vistaId, "alleleId":parseInt(_alleleId), "stage":_stage, "backbone":_backbone}});
        }
    }, []);


    return (
        <Container maxWidth="lg">
            { expContentData && 
                <ElementContent data={expContentData}></ElementContent>
            }
        </Container>
    );
}